import { render } from "./upload-file.vue?vue&type=template&id=67e31e74&scoped=true"
import script from "./upload-file.vue?vue&type=script&lang=js"
export * from "./upload-file.vue?vue&type=script&lang=js"

import "./upload-file.vue?vue&type=style&index=0&id=67e31e74&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e31e74"]])

export default __exports__